<template>
  <kez-modal
    :size="size"
    :value="value"
    @input="value => $emit('input', value)">
    <h2
      v-if="title"
      slot="header">
      {{ title }}
    </h2>
    <slot/>

    <div slot="buttons">
      <button
        type="button"
        class="btn btn-danger btn-lg"
        @click="$emit('input', false)">
        Fermer
      </button>
    </div>
  </kez-modal>
</template>

<script>
import KezModal from './KezModal';

export default {
  components: {
    KezModal,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
};
</script>
